import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api/accounts`;

// Auth lives in an httpOnly cookie set by the backend. We never touch tokens
// from JS — `withCredentials: true` sends the cookie automatically.
const http = axios.create({ withCredentials: true });

// Back-compat shim: a few callsites still import `accountToken`. All ops are
// no-ops now (the cookie is the only source of truth).
export const accountToken = {
    get: () => null,
    set: () => {},
    clear: () => {},
};

export const accountsApi = {
    register: (email, password, session_id, date_of_birth, accepted_terms) =>
        http.post(`${API}/register`, { email, password, session_id, date_of_birth, accepted_terms }).then(r => r.data),
    login: (email, password) =>
        http.post(`${API}/login`, { email, password }).then(r => r.data),
    logout: () =>
        http.post(`${API}/logout`).then(r => r.data),
    setPassword: (session_id, email, password, date_of_birth, accepted_terms) =>
        http.post(`${API}/set-password`, { session_id, email, password, date_of_birth, accepted_terms }).then(r => r.data),
    me: () => http.get(`${API}/me`).then(r => r.data),
    forgotPassword: (email) =>
        http.post(`${API}/forgot-password`, { email }).then(r => r.data),
    resetPassword: (token, password) =>
        http.post(`${API}/reset-password`, { token, password }).then(r => r.data),
    google: (session_id, app_session_id) =>
        http.post(`${API}/google`, { session_id, app_session_id }).then(r => r.data),
    googleComplete: (pending_token, date_of_birth, accepted_terms, app_session_id) =>
        http.post(`${API}/google/complete`, { pending_token, date_of_birth, accepted_terms, app_session_id }).then(r => r.data),
    deleteAccount: (confirm_text) =>
        http.post(`${API}/delete`, { confirm_text }).then(r => r.data),
    dataExport: () =>
        http.post(`${API}/data-export`).then(r => r.data),
    deletionRequest: (email, reason) =>
        http.post(`${BACKEND_URL}/api/deletion-requests`, { email, reason }).then(r => r.data),
};

export function formatAuthError(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) return detail.map(e => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
